import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../ContractVehicles/ContractVehicles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import aws_competencies from "../../assets/images/aws_competencies.png";
import star_public from "../../assets/images/star_public.png";
import GSA_pic from "../../assets/images/GSA_pic.png";

const ContractVehicles = () => {
  return (
    <div className="contract-vehicles-page">
      <Container fluid className="contract-banner-container p-0">
        <section className="contract-banner-section"></section>
      </Container>
      <section className="contract-vehicles-section">
        <Container className="my-5 px-xl-5">
          <h2 className="text-center mb-4 section-title">
            Public <span className="textgrad"> Sector Services </span>
          </h2>
          <p className="py-1 ">
            Idexcel’s solutions for the Public Sector enable them to achieve
            their goals by assisting in performing transparent operations,
            designing cost-efficient systems, and making informed decisions. We
            help expedite the transformation journey for Public Sector
            organizations to redefine experiences of citizens apart from
            modernizing and transforming their existing environments and
            constituting new capabilities to grow more affiliated, smart, and
            agile through our innovative ecosystem.
          </p>
          <p className="py-1">
            Having considerable experience across several complex governance
            projects, our technical experts conceptualize, develop, and deliver
            superior solutions that let you meet the diverse interests of your
            stakeholders. Also, with access to innovative technologies, we offer
            recommendations to our clients in their quest to meet the
            expectations of their different stakeholder groups. Our experience
            working with governments provides the ability to build value-added
            solutions with a perfect blend of management and technological
            expertise.
          </p>
          <section>
            <h2 className="text-center mb-4 section-title ">
              Our <span className="textgrad"> Partnership </span> with
              <span className="textgrad"> AWS </span>
            </h2>
            <p className="py-1">
              Idexcel is an Amazon Web Services (AWS) Advanced Tier Services
              Partner with competencies in DevOps, Migration, Financial
              Services. We are a professional services and technology solutions
              provider, specializing in Cloud, Application Modernization, and
              Data Services with about 140+ AWS Certified Consultants in various
              AWS Emerging Technologies. We have been recognized as a Public
              Sector partner with authorization to resell and service the AWS
              GovCloud.
            </p>
            <h2 className="text-black fs-4 fw-bold text-left mt-3 mb-4">
              Our AWS Competencies
            </h2>
            <div className="competence">
              <img src={aws_competencies} alt="AWS Competencies" />
            </div>
          </section>
          <section className=" mt-5">
            <h2 className="text-center mb-4 section-title">
              Why Choose <span className="textgrad"> Idexcel </span>
            </h2>
            <div className="points">
              <div className="points-list m-0 d-flex align-items-center mb-1">
                <FontAwesomeIcon icon={faAngleRight} />
                <p className="m-0 px-2">
                  We are an Amazon Web Services (AWS) Advanced Tier Services
                  Partner and Reseller more focused on supporting the AWS Cloud
                </p>
              </div>
              <div className="points-list m-0 d-flex align-items-center mb-1">
                <FontAwesomeIcon icon={faAngleRight} />
                <p className="m-0 px-2">
                  We are an AWS Public Sector Partner and Public Sector
                  Solutions Provider
                </p>
              </div>
              <div className="points-list m-0 d-flex align-items-center mb-1">
                <FontAwesomeIcon icon={faAngleRight} />
                <p className="m-0 px-2">
                  Our innovative culture enables us to introduce advanced
                  technologies to customer engagements as and when applicable
                </p>
              </div>
              <div className="points-list m-0 d-flex align-items-center mb-1">
                <FontAwesomeIcon icon={faAngleRight} />
                <p className="m-0 px-2">
                  Customer-focused flexible AWS centric approach to designing
                  solutions intended to meet client requirements
                </p>
              </div>
            </div>
          </section>
          <section className="contract mt-5">
            <Container>
              <h2 className="text-center mb-4 section-title">
                Contract <span className="textgrad">Vehicles</span>
              </h2>

              {/* First Row */}
              <Row className="align-items-center mb-5">
                <Col
                  xs={12}
                  md={4}
                  className="text-center text-md-right mb-3 mb-md-0"
                >
                  <img
                    src={star_public}
                    alt="Star Public"
                    fluid
                    className="custom-img"
                  />
                </Col>
                <Col xs={12} md={8}>
                  <p>
                    <a
                      className="text-danger"
                      href="https://www.pagexcel.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PageXcel LLC
                    </a>{" "}
                    is an SBA-approved 8(a) joint Venture (JV) between Idexcel,
                    Inc. and Page After Page, Inc. specializing in Cloud,
                    Application Modernization, and Data Services change to AI
                    Banking, Enterprise AI, Data & Analytics, Next-Gen
                    Modernization, Cloud Innovations, and Managed Cybersecurity.
                    PageXcel is focused on providing its clients with
                    intelligence, technology, and the expertise to enhance their
                    business processes. We create lasting associations for our
                    clientele by enhancing their competitive position and
                    productivity using advanced technologies.
                  </p>
                </Col>
              </Row>

              {/* Second Row */}
              <Row className="align-items-center mb-5">
                <Col
                  xs={12}
                  md={4}
                  className="text-center text-md-left mb-3 mb-md-0"
                >
                  <img src={GSA_pic} alt="GSA" fluid className="custom-img" />
                </Col>
                <Col xs={12} md={8} className="order-md-1">
                  <p>
                    <b>GSA IT Schedule 70</b> is one of the most widely used
                    acquisition vehicles among the federal, state, and local
                    governments. GSA IT Schedule 70 supports Government
                    requirements for high-performance IT by providing
                    state-of-the-art commercial hardware, software, services,
                    and solutions.
                  </p>
                  <p>
                    <b>Idexcel GSA Schedule: </b>
                    <a
                      className="text-danger text-break"
                      href="https://www.gsaelibrary.gsa.gov/ElibMain/contractorInfo.do?contractNumber=47QTCA23D0004&contractorName=IDEXCEL%2C+INC&executeQuery=YES"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.gsaelibrary.gsa.gov/ElibMain/contractorInfo.do?contractNumber=47QTCA23D0004&contractorName=IDEXCEL%2C+INC&executeQuery=YES
                    </a>
                  </p>
                </Col>
              </Row>

              {/* Button Row */}
              <Row className="justify-content-center">
                <Col xs="auto">
                  <button
                    className="button large header"
                    variant="danger"
                    href="/contract-vehicles/Idexcel-public-sector-capability-statement.pdf"
                    target="_blank"
                  >
                    Download Our Capability Statement
                  </button>
                </Col>
              </Row>
            </Container>
          </section>
        </Container>
        {/* <Row
        className="m-0 p-0  px-3 px-md-0 px-lg-0 content pt-xl-0"
        style={{ background: "#ececec" }}
      > */}
        <Container
          className="contract-vehicles-container mb-5"
          style={{ background: "#ececec" }}
        >
          <section className="contract-vehicles-section">
            <Container className="m-xl-0 p-xl-3 py-xl-4">
              <Row className="m-0 p-0 p-md-4 d-flex flex-wrap flex-md-column align-items-start contract-details">
                <Row className="m-0 p-0 mb-5 mb-md-5 mb-xl-5 pb-xl-3 pb-0 col-md-10">
                  <h2 className="text-danger fs-2 fs-xl-2 fs-lg-3 pt-5 pt-xl-0 fw-semibold mb-3">
                    Our 8(a) STARS III Contract Vehicles Details
                  </h2>
                  <h4 className="text-black px-md-4 mb-3">
                    <b>Contract No: </b>47QTCB22D0233
                  </h4>
                  <h4 className="text-black px-md-4 mb-3">
                    <b>UEI: </b>J4S9H948LZ56
                  </h4>
                  <h4 className="text-black px-md-4 mb-3">
                    <b>CAGE: </b>8Q1C5
                  </h4>
                  <h4 className="text-black px-md-4 mb-3">
                    <b>NAICS: </b>453210, 511210, 518210, 532420, 541511,
                    541512, 541513, 541611, 611430, 811211, 811212
                  </h4>
                </Row>
                <Row className="m-0 p-0 col-md-10 mb-5 mb-md-5 mb-xl-0">
                  <h2 className="text-danger fs-2 fs-lg-3 fw-semibold mb-3">
                    Idexcel GSA Schedule
                  </h2>
                  <h4 className="text-black mb-3 px-md-4">
                    <b>Contract No: </b>47QTCA23D0004
                  </h4>
                  <h4 className="text-black mb-3 px-md-4">
                    <b>UEI: </b>ZAWPKFDKKL64
                  </h4>
                  <h4 className="text-black mb-3 px-md-4">
                    <b>CAGE: </b>1XHC2
                  </h4>
                </Row>
              </Row>
            </Container>
          </section>
        </Container>
        {/* </Row> */}
        <GetInTouch />
      </section>
    </div>
  );
};

export default ContractVehicles;
